<template lang="pug">
section
  el-card(v-show="shouldShow", v-loading.body="loading")
    .cf(slot="header")
      h2 Контрагент
    el-form(label-position="top", ref="form", :model="record", :rules="rules")

      el-row
        el-col(:sm="6")
          el-form-item(prop="type", label="Тип контрагент", :rules="[{required: true}]")
            el-select(v-model="record.type")
              el-option(v-for="(v, k) in consts.contragentType", :label="v.title", :value="parseInt(k)", :key="k")
        el-col(:sm="6")
          el-form-item(prop="name", label="Име")
            el-input(v-model="record.name")
        el-col(:sm="3", v-if="record.type == 10")
          el-form-item(prop="degree", label="Титла")
            el-select(v-model="record.degree")
              el-option(label="", :value="null")
              el-option(v-for="(v, k) in consts.contragentDegree", :label="v.title", :value="k", :key="k")
        el-col(:sm="4", v-if="record.type == 10")
          el-form-item(prop="speciality", label="Специалност")
            el-select(v-model="record.speciality")
              el-option(v-for="(v, k) in consts.contragentSpeciality", :label="v", :value="k", :key="k")
        el-col(:sm="5", v-if="record.type == 10")
          el-form-item(prop="clinic", label="Клиника")
            el-input(v-model="record.clinic")
        el-col(:sm="6", v-if="record.type == 20")
          el-form-item(prop="laboratory", label="Лаборатория")
            el-input(v-model="record.laboratory")
        el-col(:sm="6", v-if="record.type == 30 || record.type == 40")
          el-form-item(prop="position", label="Длъжност")
            el-input(v-model="record.position")
      el-row
        el-col(:sm="6")
          el-form-item(prop="phone", label="Тел.")
            el-input(v-model="record.phone")
        el-col(:sm="6")
          el-form-item(prop="phone2", label="Тел.")
            el-input(v-model="record.phone2")
        el-col(:sm="12")
          el-form-item(prop="email", label="Ел. поща")
            el-input(v-model="record.email")
      el-row
        el-col(:sm="24")
          el-form-item(prop="info", label="Допълнителна информация")
            el-input(v-model="record.info", type="textarea")


      el-row
        el-col(:sm="6")
          el-form-item(prop="companyName", label="Има фирмата")
            el-input(v-model="record.companyName")
        el-col(:sm="4")
          el-form-item(prop="mol", label="МОЛ")
            el-input(v-model="record.mol")
        el-col(:sm="3")
          el-form-item(prop="eik", label="ЕИК")
            el-input(v-model="record.eik")
        el-col(:sm="3")
          el-form-item(prop="vatNumber", label="ДДС номер")
            el-input(v-model="record.vatNumber")
        el-col(:sm="8")
          el-form-item(label="Други")
            el-checkbox(v-model="record.vat") ДДС
            el-checkbox(v-model="record.vatFree") ДДС освободен
            el-checkbox(v-model="record.eInvoice") Ел. фактура

      el-row
        el-col(:sm="4")
          el-form-item(prop="invoiceAddress.postcode", label="П.К.")
            el-input(v-model="record.invoiceAddress.postcode")
        el-col(:sm="2")
          el-form-item(prop="invoiceAddress.cityType", label="гр./с.")
            el-select(v-model="record.invoiceAddress.cityType")
              el-option(v-for="(v, k) in consts.cityType", :label="v.title", :value="parseInt(k)", :key="k")
        el-col(:sm="4")
          el-form-item(prop="invoiceAddress.city", label="Населено място")
            el-autocomplete(v-model="record.invoiceAddress.city", :fetch-suggestions="cityAhead")
        el-col(:sm="4")
          el-form-item(prop="invoiceAddress.state", label="Област")
            el-input(v-model="record.invoiceAddress.state")
        el-col(:sm="10")
          el-form-item(prop="invoiceAddress.address", label="Адрес на регистрация (за фактура)")
            el-input(v-model="record.invoiceAddress.address")

      el-row
        el-col(:sm="24")
          el-form-item
            //- el-switch(on-text="", off-text="", v-model="record.useDeliveryAddress")
            el-checkbox(v-model="record.useDeliveryAddress") Използвай друг адрес за доставка

      el-row(v-show="record.useDeliveryAddress")
        el-col(:sm="4")
          el-form-item(prop="deliveryAddress.postcode", label="П.К.")
            el-input(v-model="record.deliveryAddress.postcode")
        el-col(:sm="2")
          el-form-item(prop="deliveryAddress.cityType", label="гр./с.")
            el-select(v-model="record.deliveryAddress.cityType")
              el-option(v-for="(v, k) in consts.cityType", :label="v.title", :value="parseInt(k)", :key="k")
        el-col(:sm="4")
          el-form-item(prop="deliveryAddress.city", label="Населено място")
            el-autocomplete(v-model="record.deliveryAddress.city", :fetch-suggestions="cityAhead")
        el-col(:sm="4")
          el-form-item(prop="deliveryAddress.state", label="Област")
            el-input(v-model="record.deliveryAddress.state")
        el-col(:sm="10")
          el-form-item(prop="deliveryAddress.address", label="Адрес на регистрация (за фактура)")
            el-input(v-model="record.deliveryAddress.address")

      .form-actions.cf
        el-button.fl(type="text", icon="el-icon-arrow-left", @click="$router.push(url)") Назад към списъка
        el-button.fr(type="primary", @click="onSubmit") {{ isNew ? 'Създай' : 'Запази' }}
        el-button.fr(v-if="record.id", type="danger", @click="onDelete") Изтрий

  payment-history(v-if="!isNew", :filters="{ContragentId: record.id}", :show-contragent="false")
</template>

<script>
import formMixin from '../mixins/formMixin.js'
import PaymentHistory from './PaymentHistory.vue'

export default {
  name: 'ContragentForm',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      apiUrl: '/contragents',
      url: '/contragents',
      loading: true,
      record: {
        id: null,
        type: null,
        name: '',
        degree: null,
        speciality: '',
        clinic: '',
        laboratory: '',
        position: '',
        phone: '',
        phone2: '',
        email: '',
        info: '',

        companyName: '',
        mol: '',
        eik: '',
        vatNumber: '',
        vat: false,
        vatFree: false,
        eInvoice: true,

        invoiceAddress: {
          postcode: '',
          cityType: null,
          city: '',
          state: '',
          address: ''
        },

        useDeliveryAddress: false,

        deliveryAddress: {
          postcode: '',
          cityType: null,
          city: '',
          state: '',
          address: ''
        }

      },
      rules: {
        type: {required: true, type: 'integer', message: 'Полето е задължително'},
        name: {required: true, type: 'string', min: 3, pattern: /(.*)\s(.+)/, message: 'Полето е задължително'},
        phone: {required: true, type:'string', min: 6, pattern: /^[\d\+\-\.\(\)\/\s]*$/, message: 'Полето е задължителен'},
        phone2: {type: 'string', min: 6, pattern: /^[\d\+\-\.\(\)\/\s]*$/, message: 'Телефон от поне 6 валидни символа'},
        email: {type: 'email', message: 'Невалидна ел. поща'},
        // eik: {type: 'string', pattern: /^\d+$/, message: 'Само цифри'}
      }
    }
  },
  methods: {
    cityAhead (term, cb) {
      this.$http.get('/ahead/city', {params: {term}}).then(response => {
        cb(response.data.results.map(r => { return {value: r} }))
      }).catch(error => {
        cb([])
        console.error(error)
        this.$notify.error({title: 'Error', message: 'Error loading cities. Check console.'});
      })
    }
  },
  components: {
    PaymentHistory
  }
}
</script>